import getCharts from '../getCharts'
import { SavePatientInformation } from '../../constants/api.config'

export default async function SavePatients(mode, patientInformation, facilityInformation, diagnosisInformation, patientID = -1, insurances = "") {
  try {
    const payload = { mode, patientInformation, facilityInformation, diagnosisInformation, insurances, patientID }
    const res = await getCharts(SavePatientInformation, payload)
    return res.data
  } catch (error) {
    return error
  }
}
